import React from 'react';

class ArielNetworks extends React.Component {
  render() {
    return (
    <div className="content theme-ariel">
      <div className="keywords">
        <p className="content-title"><span>k</span>eywords</p>
        <div className="content-article">
          <div className="keywords__row"><p className="keywords__label">Position</p><p className="keywords__value">System Developer (Intern)</p></div>
          <div className="keywords__row"><p className="keywords__label">Skills</p><p className="keywords__value">C · C++ · Linux · In-memory Database</p></div>
          <div className="keywords__row"><p className="keywords__label">Focus</p><p className="keywords__value">Real-time Packet Monitoring · LTE Network Services</p></div>
        </div>
      </div>
			<p className="content-title"><span>a</span>bstract</p>
      <div className="content-article content-article-paragraphs">
        <p>
          Ariel Networks is a small company made of 40 people that helps giant service provider companies, 
          such as SK telecom, LG U+, KT.
        </p>
        <p>
          I joined the team as an intern for three months. I worked on a project developing LTE network services. 
          The service provides LTE communication speed to purchased companies’ own workers based on their location.
        </p>
        <p>
          I developed a monitoring system, which first oversees the amount of traffic and abnormal conditions and then, 
          controls and manages the situation.
        </p>
      </div>
      <p className="content-title"><span>p</span>roject</p>
      <p className="content-article">
        • LTE company private network service.
      </p>
      <p className="content-title"><span>e</span>xperience</p>
      <div className="content-article content-article-list content-final">
        <p>• Assisted in building a real-time packet monitoring system for KT’s enterprise service</p>
        <p>• Developed system modules in C and C++ on Linux to process network packets in real time</p>
        <p>• Worked on an in-memory database for fast storage and retrieval of real-time packet data</p>
      </div>
    </div>
    );
  }
}

export default ArielNetworks;
